import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'iqar'
})
export class IqarPipe implements PipeTransform {

    transform(value: number, noPoluente?: any): any {

        if (value === null || value === undefined) {
            return value;
        }

        if (noPoluente && noPoluente === 'CO') {
            return value.toFixed(1);
        }

        if (value.toString().endsWith('.5')) {
            if (Math.floor(value) % 2 === 0) {
                return Math.floor(value);
            }
            return Math.floor(value) + 1;
        }

        return value.toFixed(0);
    }

}
